import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { SalatiActivationAPI } from '../api/salati/salatiactivation/salatiactivationapi';
import { SalatiActivationRequest } from '../api/salati/salatiactivation/salatiactivationrequest';
import { SalatiActivationResponse } from '../api/salati/salatiactivation/salatiactivationresponse';
import { SalatiStatusAPI } from '../api/salati/salatistatus/salatistatusapi';
import { SalatiStatusRequest } from '../api/salati/salatistatus/salatistatusrequest';
import { SalatiStatusResponse } from '../api/salati/salatistatus/salatistatusresponse';
import { SalatiToneDetailsAPI } from '../api/salati/salatitonedetails/salatitonedetailsapi';
import { SalatiToneDetailsRequest } from '../api/salati/salatitonedetails/salatitonedetailsrequest';
import { SalatiToneDetailsResponse } from '../api/salati/salatitonedetails/salatitonedetailsresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { SalatiActivationAPIProcessorImpl } from '../processor/salatiactivationapiprocessor';
import { SalatiStatusAPIProcessorImpl } from '../processor/salatistatusapiprocessor';
import { SalatiToneDetailsAPIProcessorImpl } from '../processor/salatitonedetailsapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class SalatiProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(SalatiProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getSalatiActivationDetails():APIProcessor<SalatiActivationRequest, SalatiActivationResponse>
    {
        this.logger.log("getSalatiActivationDetails() invoked");
        return new SalatiActivationAPIProcessorImpl(this.getContext(), new SalatiActivationAPI(this.getHttpClient(), this.getContext()));
    }

    getSalatiStatusDetails():APIProcessor<SalatiStatusRequest, SalatiStatusResponse>
    {
        this.logger.log("getSalatiStatusDetails() invoked");
        return new SalatiStatusAPIProcessorImpl(this.getContext(), new SalatiStatusAPI(this.getHttpClient(), this.getContext()));
    }

    getSalatiToneDetails():APIProcessor<SalatiToneDetailsRequest, SalatiToneDetailsResponse>
    {
        this.logger.log("getSalatiToneDetails() invoked");
        return new SalatiToneDetailsAPIProcessorImpl(this.getContext(), new SalatiToneDetailsAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/salatiprocessorfactory.tsx